import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import { MENU_ITEM_KEY_ASSET_TRANSACTIONS, REPORT_CONFIG_NAME_ASSET_TRANSACTIONS } from '../globals.ts'
import { resolveReportIdForMenuItem } from '../utils/reportingGridColumns.ts'

/** `reporting_config.id` for the Asset Transactions grid column layout (from global configs). */
export function useAssetTransactionsReportId(): string | undefined {
  const menuItems = useSelector((state: RootState) => state.globalConfigs?.menu_items ?? [])
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])

  return useMemo(
    () =>
      resolveReportIdForMenuItem(
        reportingConfigs,
        menuItems,
        MENU_ITEM_KEY_ASSET_TRANSACTIONS,
        REPORT_CONFIG_NAME_ASSET_TRANSACTIONS
      ),
    [menuItems, reportingConfigs]
  )
}
